import qs from 'qs'
import Vue from 'vue'

const profileQuestionCodes = [
  {
    code: 'language_preference',
    required: true,
  },
  {
    code: 'first_name',
    required: true,
  },
  {
    code: 'last_name',
    required: true,
  },
  {
    code: 'gender',
    required: true,
  },
  {
    code: 'dob',
    required: true,
  },
  {
    code: 'pronouns',
    required: true,
  },
  {
    code: 'race',
    required: false,
  },
]

export const state = () => ({
  loadingQuestions: false,
  questionsWithAnswers: [],
  questionsOnly: [],
})

export const mutations = {
  setLoading(state, status) {
    state.loadingQuestions = status
  },

  setQuestions(state, { questions, loadAnswers }) {
    if (loadAnswers) {
      state.questionsWithAnswers = questions
    } else {
      state.questionsOnly = questions
    }
  },
  updateQuestions(state, { questions, loadAnswers }) {
    const updateState = (questions, stateQuestions) => {
      for (const question of questions) {
        const index = stateQuestions.findIndex(
          ({ code }) => code === question.code
        )
        Vue.set(stateQuestions, index, question)
      }
    }

    console.log('questions: ', questions)
    console.log('questionsWithAnswers: ', questionsWithAnswers)

    updateState(
      questions,
      loadAnswers ? state.questionsWithAnswers : state.questionsOnly
    )
  },
}

const normalizedAnwers = (questions) => {
  if (!questions) return

  const _answersNormalized = {}
  questions.forEach((question) => {
    if (question.value?.value) {
      _answersNormalized[question.code] = question.value.value
    } else {
      _answersNormalized[question.code] = question.value
    }
  })

  return _answersNormalized
}

export const actions = {
  async loadQuestions(context, { codes, loadAnswers }) {
    try {
      context.commit('setLoading', true)

      const questionsCodes = codes.map((code) => code.code)

      const questions = await this.$axios.$get(
        '/CORE_URL/smart-surveys/me/questions',
        {
          params: {
            codes: questionsCodes,
            answers: loadAnswers,
          },
          paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: 'repeat' }),
        }
      )

      context.commit('setQuestions', { questions, loadAnswers })
      context.dispatch('setLocale', { questions, loadAnswers })
    } catch (e) {
      console.log('Error getting questions', e)
    } finally {
      context.commit('setLoading', false)
    }
  },

  async save(context, { questions, withAnswers, skipInstructions }) {
    const entityUuid = context?.rootState?.fiiAuth?.identity?.entityUuid

    console.log('instruction and responder ID:', Boolean(entityUuid))

    if (!entityUuid) {
      return {
        success: false,
        message: this.app.i18n.t('try_again'),
      }
    }

    const data = questions.map((question) => {
      return {
        instructions_entity_uuid: entityUuid,
        responder_entity_uuid: entityUuid,
        subject_entity_type: question.subject.entity_type,
        subject_entity_code: entityUuid,
        locale: this.$i18n.locale,
        question_hash: question.question_hash,
        response_body: question.value,
      }
    })

    const params = {}
    if (skipInstructions) {
      params.skip_instructions = true
    }

    console.log('data: ', data)
    console.log('params: ', params)
    console.log('withAnswers: ', withAnswers)

    return await this.$axios
      .$post(`/CORE_URL/smart-surveys/me/responses`, data, { params })
      .then(() => {
        context.commit('updateQuestions', {
          questions,
          loadAnswers: withAnswers,
        })
        return {
          success: true,
          message: 'Updated',
          body: normalizedAnwers(questions),
        }
      })
      .catch(() => {
        return { success: false, message: 'Error' }
      })
  },

  loadProfileQuestions(context) {
    context.dispatch('loadQuestions', {
      codes: profileQuestionCodes,
      loadAnswers: true,
    })
  },
  setLocale({ rootState }, { questions, loadAnswers }) {
    // Set preferred language from questions
    if (!loadAnswers) return

    /** @type {{ languagePreference: { language?: string, other: string} }} */
    const { languagePreference } = rootState.fiiAuth.identity.meta
    /** @type {{ code: string, value?: string }} */
    const languageQuestion = questions.find(
      ({ code }) => code === 'language_preference'
    )?.value
    /**
     * Get the preferred language from the questions, or the default locale from the authentication store
     * @type {string|undefined}
     */
    const locale = languageQuestion?.value ?? languagePreference?.language
    if (!locale) return
    this.$i18n.setLocale(locale)
  },
}
